import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AppearDisappearAnimations} from '../animations/appearDisappearAnimations';

@Component({
  selector: 'tcore-button-confirm',
  templateUrl: './button-confirm.component.html',
  styleUrls: ['./button-confirm.component.css'],
  animations: [
    AppearDisappearAnimations.widthOpacityTrigger()
  ]
})
export class ButtonConfirmComponent implements OnInit {
  @Input() confirmTitleKey = 'confirm';
  @Input() titleKey: string;
  @Input() iconClass: string;
  @Input() btnsClass: string;
  @Input() mainBtnClass = 'btn-danger';

  @Input() confirmActive = false;

  @Input() confirmDeactivate = false;

  @Output() activate = new EventEmitter();
  @Output() confirm = new EventEmitter();
  @Output() cancel = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  doAction() {
    if (!this.confirmDeactivate) {
      this.confirmActive = false;
    }
    this.confirm.emit({callback: (doThat) => {
      if (doThat) {
        this.confirmActive = false;
      }
    }});
  }

  cancelAction() {
    this.confirmActive = false;
    this.cancel.emit();
  }

  showDoCancel() {
    this.confirmActive = true;
    this.activate.emit();
  }
}
